module.exports = __webpack_public_path__ + "static/media/redis.7feaace4.svg";